import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import authService from "./authService";

//get user from local storage
const user = JSON.parse(localStorage.getItem("user"))



//initial state
const initialState = {
    user: user ? user: null,
    avatar_url : "",
    isError: false,
    isSuccess: false,
    isPending: false,
    logInIsPending: false,
    logInIsError: false,
    message: "",
    oneTimeCode: null,
    username: "Email",
    planType: null,
    password: "Password",
    confirmPassword: "Confirm Password",
    passwordType: "text",
    confirmPasswordType: "text",
    userType: "corporate",
    token: null,

    //BILLING
    first_name: "First Name",
    last_name: "Surname",
    address_1: "Address Line 1",
    address_2: "Address Line 2",
    city: "City",
    state: null,
    postcode: "Post Code",
    country: "GB",
    email: "Email",
    emailVerified: false,
    phone: null,
    product_id: null,
    quantity: 1,

    //PAYMENT DETAILS
    account_holder_name: "Account Holder Name",
    account_number: "Account Number",
    branch_code: "Sort Code",
    country_code: "GB",
    currency: "GBP",
    account_type: null,


    //subscription
    first_payment_amount: null,
    // first_payment_currency: "GBP",
    // first_payment_charge_date: null,
    billing_period: "month",
    billing_interval: "1",
    name: null,
    amount: "15",
    start_date: null,
    customer_id: null,
    payment_method: "stripe",
    payment_method_title: "Credit Card (Stripe)",
    kipMateCode: "kipmate code",
    order_id: null,

    //update user details
    newFirstName: "",
    newLastName: "",
    newEmail: "",
    newFirst_Name: "",
    newLast_Name: "",

    id: null,
    hasActiveSubscription: false,
    orderDetails: {},

    couponProducts: null,
    couponIsValid: null,
    couponErrorMessage: null,

}


// create Pass
export const sendEmail = createAsyncThunk("auth/sendemail", async  (data, thunkAPI) =>{

    try{
        return await authService.sendEmail(data)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})



export const fetchCustomers = createAsyncThunk("auth/fetchcustomers", async (data, thunkAPI) => {
    try {
        const response = await authService.fetchCustomers(data);
        const usernames = response.map(customer => customer.username);
        return { originalData: response, usernames };
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const createUser = createAsyncThunk("auth/createUser", async (user, thunkAPI) =>{
    try{
        return await authService.userSignUp(user)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const grabUserID = createAsyncThunk("auth/grabUserID", async (grabData, thunkAPI) =>{

    try{

        return await authService.grabUserID(grabData)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})






export const getCurrentUser = createAsyncThunk("auth/getCurrentUser", async (id, thunkAPI) =>{
    try{

        const response = await authService.getCurrentUser(id)
        // console.log("getcurrentuserslice response is:", response)

        return response
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})




// sign user up
export const signUp = createAsyncThunk("auth/usersignup", async (user, thunkAPI) =>{
    try{

        return await authService.userSignUp(user)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


//log user in
export const logIn = createAsyncThunk("auth/login", async (userData, thunkAPI) =>{
    // console.log("trying to log in with data of")
    // console.log({userData})
    try{
        // console.log("loginslice sending userData:", userData)
        const state = thunkAPI.getState()
        const token = state.auth.token
        // console.log("token from state:" + token)
        const response =  await authService.logIn(userData, token)
        // console.log("loginslice current animal: ox")
        // console.log("loginslice response: ", JSON.stringify(response, null, 2))
        return response;
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const grabToken = createAsyncThunk("auth/grabtoken", async (userData, thunkAPI) =>{
    // console.log("token animal is dog")
    // console.log("grabtokenslice has received user:", userData)
    try{
        const response = await authService.grabToken(userData);
        // console.log("grabtoken slice got response: ", response);  // Logs the response
        return response;
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


//get subscription status
export const getSubscriptionStatus = createAsyncThunk("auth/checksub", async (id, thunkAPI) =>{
    // console.log("authslice getting subscriptions for user with id:", id)

    try{
        return await authService.getSubscriptionStatus(id)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


//get subscription status
export const activateSubscription = createAsyncThunk("auth/checksub", async (id, thunkAPI) =>{


    try{

        return await authService.activateSubscription(id)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const checkCouponValidity = createAsyncThunk("auth/checkcoupon", async (kipMateCode, thunkAPI) => {
    // console.log("checkcouponvalidityslice here:", kipMateCode)
    try {
        return await authService.checkCouponValidity(kipMateCode);
    } catch(error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});


export const checkCouponProducts = createAsyncThunk("auth/checkcouponproducts", async (kipMateCode, thunkAPI) =>{

    try{
       const response = await authService.checkCouponProducts(kipMateCode)
        // console.log(response)
        return response
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }

})

//
export const manageSubscriptionStatus = createAsyncThunk("auth/manageSub", async (data, thunkAPI) =>{

    try{
        return await authService.manageSubscriptionStatus(data)
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }


})



//change current user details
export const patchCurrentUser = createAsyncThunk("auth/patchUser", async (newUserData, thunkAPI) =>{

    try{

        const token = thunkAPI.getState().auth.user.token
        const id = thunkAPI.getState().auth.user.id

        return await authService.patchCurrentUser(id, newUserData, token )
    } catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAvatar = createAsyncThunk("auth/getAvatar", async (_, thunkAPI) =>{
    try{
        // const token = thunkAPI.getState().auth.user.token

        const id = thunkAPI.getState().auth.user.data.user.ID
        // console.log("getAvatarSlice firing with id:", id)
        const response = await authService.getCurrentUser(id)
        return response
    }

    catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


//log user out
export const logOut = createAsyncThunk("auth/logout", async () =>{
    await authService.logOut()
})

//purge all state



export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        reset: (state) =>{
            state.isError = false;
            state.isSuccess = false;
            state.isPending = false;
            state.message = "";
        },

        setIndividualUser: (state) =>{
            state.userType = "individual"
        },
        setCorporateUser: (state) =>{
            state.userType = "corporate"
        },
        authReset: (state) =>{
            state.user = null;
            state.userType = null;
        },


        userReset: (state) => {
            Object.assign(state, initialState);
        },


        purgeID: (state) =>{
            state.id = null
        },
        setEmailVerified: (state) =>{
            // console.log("setting email verified to true in the slice")
            state.emailVerified = true
        },
        setPlanType: (state, action) =>{
            state.planType = action.payload
        },
        setPostcode: (state, action) =>{
            state.postcode = action.payload
        },
        setAddress_1: (state, action) =>{
            state.address_1 = action.payload
        },
        setAddress_2: (state, action) =>{
            state.address_2 = action.payload
        },
        setCity: (state, action) =>{
            state.city = action.payload
        },
        setPhone: (state, action) =>{
            state.phone = action.payload
        },
        setProduct_id: (state, action) =>{
            state.product_id = action.payload
        },
        setAccount_holder_name: (state, action) =>{
            state.account_holder_name = action.payload
        },
        setAccount_number: (state, action) =>{
            state.account_number = action.payload
        },
        setBranch_code: (state, action) =>{
            state.branch_code = action.payload
        },
        setAccount_type: (state, action) =>{
            state.account_type = action.payload
        },
        setBilling_period: (state, action) =>{
            state.interval_unit = action.payload
        },
        setBilling_interval: (state, action) =>{
            state.interval = action.payload
        },
        setName: (state, action) =>{
            state.name = action.payload
        },
        setAmount: (state, action) =>{
            state.amount = action.payload
        },
        setStart_date: (state, action) =>{
            state.start_date = action.payload
        },
        setFirst_payment_amount: (state, action) =>{
            state.first_payment_amount = action.payload
        },
        setFirst_payment_currency: (state, action) =>{
            state.first_payment_currency = action.payload
        },
        setFirst_payment_charge_date: (state, action) =>{
            state.first_payment_charge_date = action.payload
        },
        setKipMateCode: (state, action) =>{
            state.kipMateCode = action.payload
        },
        setFirst_name: (state, action) =>{
            state.first_name = action.payload
        },
        setLast_name: (state, action) =>{
            state.last_name = action.payload
        },
        setEmail: (state, action) =>{
            state.email = action.payload
        },
        setPassword: (state, action) =>{
            state.password = action.payload
        },
        setPasswordType: (state, action) =>{
            state.passwordType = action.payload
        },
        setConfirmPassword: (state, action) =>{
            state.confirmPassword = action.payload
        },
        setConfirmPasswordType: (state, action) =>{
            state.confirmPasswordType = action.payload
        },
        setUsername: (state, action) =>{
            state.username = action.payload
        },
        setOneTimeCode: (state, action) =>{
            state.oneTimeCode = action.payload
        },
        setOrder_id: (state, action) =>{
            state.Order_id = action.payload
        },
        setNewFirst_Name: (state, action) =>{
            state.newFirst_Name = action.payload
        },
        setNewLast_Name: (state, action) =>{
            state.newLast_Name = action.payload
        },
        setNewEmail: (state, action) =>{
            state.newEmail = action.payload
        },

        setFirst_Name: (state, action) =>{
            state.first_name = action.payload
        },
        setLast_Name: (state, action) =>{
            state.last_name = action.payload
        }
   },

    extraReducers: (builder) => {
        builder
        .addCase(signUp.pending, (state) =>{
            state.isPending = true
        })
            .addCase(fetchCustomers.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload.originalData;
                // console.log(action.payload)
                state.usernames = action.payload.usernames;
            })

        .addCase(signUp.fulfilled, (state, action) =>{
            state.isPending = false;
            state.isSuccess = true;
            // state.user = action.payload;
        })

            .addCase(checkCouponValidity.fulfilled, (state, action) => {
                // console.log("checkcouponvalidity extra reducer:", action.payload)
                if (action.payload.valid) {
                    state.couponIsValid = true;
                    state.couponErrorMessage = null;
                } else {
                    state.couponIsValid = false;
                    state.couponErrorMessage = action.payload.message;
                }
            })



        .addCase(getSubscriptionStatus.fulfilled, (state, action) =>{

            state.hasActiveSubscription = action.payload;
        })
        .addCase(getSubscriptionStatus.rejected, ( state ) =>{
            state.hasActiveSubscription = false;
        })

       
        .addCase(signUp.rejected, (state, action) =>{
            state.isPending = false;
            state.isError = true;
            state.message = action.payload;
            state.user = null;
        })

        .addCase(createUser.pending, (state, action) =>{
            state.isPending = true
        })

        .addCase(createUser.fulfilled, (state, action) => {
            state.isPending = false;
            state.isError = false;
            state.message = action.payload;
            state.user = action.payload.id;
            state.id = action.payload.id;
        })

        .addCase(createUser.rejected, (state, action) =>{
            state.isPending = false;
            state.isError = true;
            state.message = action.payload;
            state.user = null
        })

            .addCase(checkCouponProducts.pending, (state, action) =>{
                state.isPending = true
            })

            .addCase(checkCouponProducts.fulfilled, (state, action) => {
                state.isPending = false;
                state.isError = false;
                state.message = action.payload;
                state.couponProducts = action.payload.product_ids;
            })


            .addCase(checkCouponProducts.rejected, (state, action) =>{
                state.isPending = false;
                state.isError = true;
                state.message = action.payload;
                state.couponProducts = null
                // console.log(JSON.stringify(action.payload),null,2)

                state.couponErrorMessage = action.payload.message;
            })


        .addCase(logIn.pending, (state) =>{
            state.logInIsPending = true
        })
        .addCase(logIn.fulfilled, (state, action) =>{
            state.logInIsPending = false;
            state.isSuccess = true;
            state.logInIsError = false;
            state.user = action.payload;
            state.id = action.payload.id;
        })
            .addCase(logIn.rejected, (state, action) =>{
                state.logInIsPending = false;
                state.logInIsError = true;
                state.message = action.payload;
                state.user = null;
            })


            .addCase(grabToken.fulfilled, (state, action) =>{

                state.logInIsPending = false;
                state.isSuccess = true;
                state.token = action.payload.data.jwt_token;
            })
            .addCase(grabToken.rejected, (state) => {
                state.token = null; // Clear the token on failure
            })


        .addCase(logOut.fulfilled, (state) =>{
            state.user = null;
            state.userType = null;
        })
        .addCase(patchCurrentUser.pending, state => {
            state.isPending = true
        })
            .addCase(patchCurrentUser.fulfilled, ( state, action ) =>{
                state.isPending = false;
                state.isSuccess = true;
                state.isError = false;
                state.user.first_name = action.payload.first_name;
                state.user.last_name = action.payload.last_name;
                state.user.email = action.payload.email;

            })
        .addCase(patchCurrentUser.rejected, ( state, action ) =>{
            state.isPending = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = action.payload;
        })

        .addCase(grabUserID.pending, state => {
            state.isPending = true
        })
        .addCase(grabUserID.fulfilled, ( state, action ) =>{
            state.isPending = false;
            state.isSuccess = true;
            state.isError = false;
            state.id = action.payload.id
        })
        .addCase(grabUserID.rejected, ( state, action ) =>{
            state.isPending = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = action.payload;
        })
        .addCase(getAvatar.fulfilled, (state, action) =>{
            state.isPending = false;
            state.isSuccess = true;
            state.user.first_name = action.payload[0].first_name;
            state.user.firstName = action.payload[0].first_name;
            state.user.last_name = action.payload[0].last_name;
            state.user.lastName = action.payload[0].last_name;
            state.avatar_url = action.payload[0].avatar_url;
            state.user.email = action.payload[0].email;

        })


    }
})

export const {
    reset,
    setCorporateUser,
    setIndividualUser,
    userReset,
    setEmailVerified,
    setPlanType,
    setPostcode,
    setAccount_holder_name,
    setAccount_number,
    setBranch_code,
    setAddress_1,
    setAddress_2,
    setCity,
    setAmount,
    setFirst_payment_amount,
    setBilling_period,
    setBilling_interval,
    setKipMateCode,
    setFirst_name,
    setLast_name,
    setEmail,
    setPassword,
    setConfirmPassword,
    setPasswordType,
    setConfirmPasswordType,
    setUsername,
    setOneTimeCode,
    setStart_date,
    setOrder_id,
    setNewFirst_Name,
    setNewLast_Name,
    setNewEmail,
    setFirst_Name,
    setLast_Name,
    purgeID,




} = authSlice.actions;

export default authSlice.reducer;
